"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBookingByPermalinkExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const deserializer_1 = tslib_1.__importDefault(require("../../../utils/deserializer"));
const services_1 = tslib_1.__importDefault(require("../../../services"));
// TODO: Change the import to shared Models
const Booking_1 = tslib_1.__importDefault(require("../../saas/bookings/__models__/Booking"));
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getBookingByPermalink = toolkitRaw.createAsyncThunk('bookings/fetch_booking_by_permalink', async ({ permalink }, { rejectWithValue }) => {
    try {
        const response = await services_1.default.get(`/api/links/${permalink}`, {
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('links_permalink'),
            },
        });
        const payload = (0, deserializer_1.default)(response.data);
        const BookingImplementation = new Booking_1.default(payload);
        return BookingImplementation.data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getBookingByPermalinkExtraReducers = (builder) => {
    builder.addCase(getBookingByPermalink.pending, (state) => {
        state.booking.loading = true;
    });
    builder.addCase(getBookingByPermalink.fulfilled, (state, action) => {
        var _a, _b;
        state.booking.loading = false;
        state.booking.data = action.payload;
        if ((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.insured_until) {
            state.booking.slices.insurances.meta.until =
                action.payload.meta.insured_until;
        }
    });
    builder.addCase(getBookingByPermalink.rejected, (state) => {
        state.booking.loading = false;
    });
};
exports.getBookingByPermalinkExtraReducers = getBookingByPermalinkExtraReducers;
exports.default = getBookingByPermalink;
//# sourceMappingURL=index.js.map